//文字コードはutf-8

/**
 * スムーススクロールの初期化
 * #で始まる全てのアンカーリンクをスムーススクロールにする
 */
export function initSmoothScroll() {
  /**
   * イージング関数（easeInOutQuad）
   */
  const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  /**
   * スムーススクロールアニメーション
   */
  const smoothScrollTo = (targetPosition, duration = 800) => {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const startTime = performance.now();

    const animation = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const ease = easeInOutQuad(progress);
      
      window.scrollTo(0, startPosition + distance * ease);

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  };

  // イベント委譲を使用して動的に追加されるリンクにも対応
  document.addEventListener('click', (e) => {
    // クリックされた要素がaタグか、その中にいるか確認
    const link = e.target.closest('a[href^="#"]');
    
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    // hrefが#のみの場合（ページトップ）もしくは空の場合はスキップ
    if (!href || href === '#') return;
    
    // 対象の要素を取得
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);
    
    // 対象要素が存在する場合のみスムーススクロール
    if (targetElement) {
      e.preventDefault();
      
      // ヘッダーの高さ分の余白（固定値：SPの場合は小さくする）
      const isSmartphone = window.innerWidth <= 768;
      const headerOffset = isSmartphone ? 40 : 80;
      
      // 対象要素の位置を取得（ヘッダーの高さ分を引く）
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      
      // スムーススクロール実行
      smoothScrollTo(targetPosition);
      
      // URLのハッシュを更新（履歴に追加）
      history.pushState(null, '', href);
    }
  });
}

